import axios from "axios";
import { useQuery } from "react-query";
import { UserInfo } from "../types/userInfo";

const fetchUserInfo = async (key?: string): Promise<UserInfo> => {
	console.log("i am in get user-info stuff");
  const { data } = await axios.get("https://imirt.ca:4051/api/userinfo/", { params: { "key":key } });
  console.log(data);
  return data;
};

export function useUserInfo(key?: string) {
	console.log("i am key");
	console.log("sap " + !!key);
  return useQuery(["userinfo", key], () => fetchUserInfo(key), {
    enabled: !!key,
  });
}
